import { Spinner } from '@/components/ui/Spinner'
import { useT } from '@/i18n'
import { LogoMark } from './Logo'

export function Splash() {
  const t = useT()
  return (
    <div className="flex h-dvh flex-col items-center justify-center gap-5">
      <LogoMark className="h-12" />
      <Spinner className="size-4.5 text-muted" label={t('layout.restoringSession')} />
    </div>
  )
}
